import { render, staticRenderFns } from "./EmailResetForm.vue?vue&type=template&id=1f6200a1"
import script from "./EmailResetForm.vue?vue&type=script&lang=js"
export * from "./EmailResetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports